const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

//Import Designs
import { Typography, Link, SvgIcon, Backdrop, CircularProgress } from '@mui/material';
import { encode } from 'html-entities';

import FacebookIcon from '@mui/icons-material/Facebook';
import PinterestIcon from '@mui/icons-material/Pinterest';
import RedditIcon from '@mui/icons-material/Reddit';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TitleIcon from '@mui/icons-material/Title';
import XIcon from '@mui/icons-material/X';

const ThreadsIcon = (props) => {
    return (<SvgIcon viewBox="0 0 448 512" {...props}>
        {/* !Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc. */}
        <path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM294.2 244.3c19.5 9.3 33.7 23.5 41.2 40.9c10.4 24.3 11.4 63.9-20.2 95.4c-24.2 24.1-53.5 35-95.1 35.3h-.2c-46.8-.3-82.8-16.1-106.9-46.8C91.5 341.8 80.4 303.7 80 256v-.1-.1c.4-47.7 11.5-85.7 33-113.1c24.2-30.7 60.2-46.5 106.9-46.8h.2c46.9 .3 83.3 16 108.2 46.6c12.3 15.1 21.3 33.3 27 54.4l-26.9 7.2c-4.7-17.2-11.9-31.9-21.4-43.6c-19.4-23.9-48.7-36.1-87-36.4c-38 .3-66.8 12.5-85.5 36.2c-17.5 22.3-26.6 54.4-26.9 95.5c.3 41.1 9.4 73.3 26.9 95.5c18.7 23.8 47.4 36 85.5 36.2c34.3-.3 56.9-8.4 75.8-27.3c21.5-21.5 21.1-47.9 14.2-64c-4-9.4-11.4-17.3-21.3-23.3c-2.4 18-7.9 32.2-16.5 43.2c-11.4 14.5-27.7 22.4-48.4 23.5c-15.7 .9-30.8-2.9-42.6-10.7c-13.9-9.2-22-23.2-22.9-39.5c-1.7-32.2 23.8-55.3 63.5-57.6c14.1-.8 27.3-.2 39.5 1.9c-1.6-9.9-4.9-17.7-9.8-23.4c-6.7-7.8-17.1-11.8-30.8-11.9h-.4c-11 0-26 3.1-35.6 17.6l-23-15.8c12.8-19.4 33.6-30.1 58.5-30.1h.6c41.8 .3 66.6 26.3 69.1 71.8c1.4 .6 2.8 1.2 4.2 1.9l.1 .5zm-71.8 67.5c17-.9 36.4-7.6 39.7-48.8c-8.8-1.9-18.6-2.9-29-2.9c-3.2 0-6.4 .1-9.6 .3c-28.6 1.6-38.1 15.5-37.4 27.9c.9 16.7 19 24.5 36.4 23.6l-.1-.1z" />
    </SvgIcon>
    );
}


class ContestantSocial extends Component {
    constructor(props) {
        super(props);
        this.state = { fb_icon: '', threads_icon: '', tw_icon: '', pin_icon: '', redit_icon: '', linked_icon: '', tum_icon: '' };
    }

    componentDidMount = () => {
        this.setState({
            fb_icon: this.props.settings.color.votes_social_icon_color,
            threads_icon: this.props.settings.color.votes_social_icon_color,
            tw_icon: this.props.settings.color.votes_social_icon_color,
            pin_icon: this.props.settings.color.votes_social_icon_color,
            redit_icon: this.props.settings.color.votes_social_icon_color,
            linked_icon: this.props.settings.color.votes_social_icon_color,
            tum_icon: this.props.settings.color.votes_social_icon_color
        });
    }

    toggleHover = (value, name) => () => {
        switch (name) {
            case 'fb_icon':
                this.setState({ fb_icon: value })
                break;
            case 'threads_icon':
                this.setState({ threads_icon: value })
                break;
            case 'tw_icon':
                this.setState({ tw_icon: value })
                break;
            case 'pin_icon':
                this.setState({ pin_icon: value })
                break;
            case 'redit_icon':
                this.setState({ redit_icon: value })
                break;
            case 'linked_icon':
                this.setState({ linked_icon: value })
                break;
            case 'tum_icon':
                this.setState({ tum_icon: value })
                break;
        }
    }

    toggleleave = (value, name) => () => {
        switch (name) {
            case 'fb_icon':
                this.setState({ fb_icon: value })
                break;
            case 'threads_icon':
                this.setState({ threads_icon: value })
                break;
            case 'tw_icon':
                this.setState({ tw_icon: value })
                break;
            case 'pin_icon':
                this.setState({ pin_icon: value })
                break;
            case 'redit_icon':
                this.setState({ redit_icon: value })
                break;
            case 'linked_icon':
                this.setState({ linked_icon: value })
                break;
            case 'tum_icon':
                this.setState({ tum_icon: value })
                break;
        }
    }

    render() {
        const { votes_social_font_size, votes_social_icon_color, votes_social_icon_color_hover } = this.props.settings.color;
        const { facebook, threads, linkedin, pinterest, tumblr, reddit, twitter } = this.props.settings.share;
        if (this.props.singlepost) {
            return (

                <Typography component="p" className="wpvc_social_icon" >
                    {facebook == 'on' &&
                        <Link href={"https://www.facebook.com/sharer.php?u=" + encodeURI(this.props.singlepost.link) + "&t=" + encode(this.props.singlepost.post_title)} target="_blank">
                            <FacebookIcon
                                style={{ fontSize: votes_social_font_size + 'px', 'color': this.state.fb_icon }}
                                onMouseOver={this.toggleHover(votes_social_icon_color_hover, 'fb_icon')}
                                onMouseLeave={this.toggleleave(votes_social_icon_color, 'fb_icon')}
                            />
                        </Link>
                    }
                    {threads == 'on' &&
                        <Link href={"https://www.threads.net/intent/post?text=" + encode(this.props.singlepost.post_title) + '%20' + encodeURI(this.props.singlepost.link)} target="_blank">
                            <ThreadsIcon
                                style={{ fontSize: votes_social_font_size + 'px', 'color': this.state.threads_icon }}
                                onMouseOver={this.toggleHover(votes_social_icon_color_hover, 'threads_icon')}
                                onMouseLeave={this.toggleleave(votes_social_icon_color, 'threads_icon')}
                            />
                        </Link>
                    }
                    {twitter == 'on' &&
                        <Link href={"https://twitter.com/share?text=" + encode(this.props.singlepost.post_title) + '%20' + encodeURI(this.props.singlepost.link)} target="_blank">
                            <XIcon
                                style={{ fontSize: votes_social_font_size + 'px', 'color': this.state.tw_icon }}
                                onMouseOver={this.toggleHover(votes_social_icon_color_hover, 'tw_icon')}
                                onMouseLeave={this.toggleleave(votes_social_icon_color, 'tw_icon')}
                            />
                        </Link>
                    }{pinterest == 'on' &&
                        <Link href={"https://www.pinterest.com/pin/create/button/?url=" + encode(this.props.singlepost.link) + "&description=" + encode(this.props.singlepost.post_title) + "&media=" + encode(this.props.singlepost.featured_image_url)} target="_blank">
                            <PinterestIcon
                                style={{ fontSize: votes_social_font_size + 'px', 'color': this.state.pin_icon }}
                                onMouseOver={this.toggleHover(votes_social_icon_color_hover, 'pin_icon')}
                                onMouseLeave={this.toggleleave(votes_social_icon_color, 'pin_icon')}
                            />
                        </Link>
                    }{reddit == 'on' &&
                        <Link href={"https://reddit.com/submit?url=" + encode(this.props.singlepost.link) + "&title=" + encode(this.props.singlepost.post_title)} target="_blank">
                            <RedditIcon
                                style={{ fontSize: votes_social_font_size + 'px', 'color': this.state.redit_icon }}
                                onMouseOver={this.toggleHover(votes_social_icon_color_hover, 'redit_icon')}
                                onMouseLeave={this.toggleleave(votes_social_icon_color, 'redit_icon')}
                            />
                        </Link>
                    }{linkedin == 'on' &&
                        <Link href={"https://www.linkedin.com/shareArticle?mini=true&url=" + encode(this.props.singlepost.link) + "&title=" + encode(this.props.singlepost.post_title)} target="_blank">
                            <LinkedInIcon
                                style={{ fontSize: votes_social_font_size + 'px', 'color': this.state.linked_icon }}
                                onMouseOver={this.toggleHover(votes_social_icon_color_hover, 'linked_icon')}
                                onMouseLeave={this.toggleleave(votes_social_icon_color, 'linked_icon')}
                            />
                        </Link>
                    }{tumblr == 'on' &&
                        <Link href={"https://www.tumblr.com/share/photo?source=" + encode(this.props.singlepost.featured_image_url) + "&caption='" + encode(this.props.singlepost.post_title) + "&clickthru=" + encode(this.props.singlepost.link)} target="_blank">
                            <TitleIcon
                                style={{ fontSize: votes_social_font_size + 'px', 'color': this.state.tum_icon }}
                                onMouseOver={this.toggleHover(votes_social_icon_color_hover, 'tum_icon')}
                                onMouseLeave={this.toggleleave(votes_social_icon_color, 'tum_icon')}
                            />
                        </Link>
                    }

                </Typography>

            )
        } else {
            return <Backdrop className="wpvc_back_loader" open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        }

    }
}

export default connect()(withTranslation("translations")(ContestantSocial));
